import { FC, useState } from "react";
import FolderSVG from "../../../assets/svg/folderGris.svg"
import FolderBlueSVG from "../../../assets/svg/folderAzul.svg"
import { ButtonBase, ButtonBaseProps, styled } from "@mui/material";


const Image = styled('span')(({ }) => ({
    display: 'inline-block',
    '& svg': {
        width: '100%',
        height: '100%',
        fill: 'currentColor',
    }
}))

const EnchancedButton = styled(ButtonBase)(({ }) => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))

const CustomImg = styled('img')(({ }) => ({
    zIndex: '1 !important',
    position: 'relative'
}))



const ButtonFolder: FC<ButtonBaseProps> = ({ ...props }) => {

    const [isHovered, setIsHovered] = useState(false);
    return (
        <EnchancedButton {...props}>
            <Image
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <CustomImg src={isHovered ? FolderBlueSVG : FolderSVG} alt="Folder Icon" style={{ width: '100%' }} />
            </Image>
        </EnchancedButton>
    )
}

export default ButtonFolder